import { useEffect, useState } from "react";
import api from "./api";
import { images, pillars, timeline, notableFigures, faqs, lodge } from "../data/content";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const mediaUrl = (id) => `${BACKEND}/api/media/${id}/raw`;

export function resolveImage(ref) {
  if (!ref) return "";
  if (ref.startsWith("media:")) return mediaUrl(ref.slice(6));
  return images[ref] || ref;
}

const FALLBACK = {
  blocks: {
    home_hero: {
      eyebrow: "District Grand Lodge of the Eastern Archipelago · English Constitution",
      title_lead: "Singapore's Oldest ", title_highlight: "Masonic Lodge.", title_tail: "Established 1845.",
      subtitle: "One hundred and eighty years of heritage tied to the founding of modern Singapore — and a living brotherhood of men building a better world, together.",
      cta_primary_label: "Learn Our Story", cta_primary_to: "/history",
      cta_secondary_label: "Begin an Inquiry", cta_secondary_to: "/visit",
    },
    home_pillars: { items: pillars },
    history_timeline: { items: timeline },
    history_figures: { items: notableFigures },
    freemasonry_faqs: { items: faqs },
    visit_details: lodge,
  },
  articles: [],
};

let cache = null;

export function useSiteContent() {
  const [content, setContent] = useState(cache || FALLBACK);
  useEffect(() => {
    let alive = true;
    api.get("/public/content").then(({ data }) => {
      cache = data;
      if (alive) setContent(data);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const block = (key) => ({ ...FALLBACK.blocks[key], ...(content.blocks?.[key] || {}) });
  return { block, articles: content.articles || [], loaded: !!cache };
}

export function fmtPubDate(d) {
  if (!d) return "";
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}
